import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";

const atenderTurnoADP = async ({ id, token, callbacks }) => {
    const response = await connection({ method: 'PUT', url: `${ENTITY_URL.ADP.TURNOS.ATENDER_TURNO}${id}`, extraHeaders: { token: token } });
    if (typeof callbacks === "function") {
        callbacks(response);
    }
}
export default atenderTurnoADP;